import { useIntl, type UserRequirement, type UserUK24HourCooldownRequirementConfig } from '@capsicum/common';
import { useMemo } from 'react';

export const useUkCooldown = (requirement: UserRequirement) => {
	const { $t } = useIntl();

	const countdown = useMemo(() => {
		const config = requirement.config as UserUK24HourCooldownRequirementConfig;
		const seconds = parseInt(config.blockedUntil as string) as number;
		const hours = Math.floor(seconds / 3600);
		const minutes = Math.floor((seconds % 3600) / 60);

		return `${hours}${$t('global.time.hourShort')}:${minutes.toString().padStart(2, '0')}${$t(
			'global.time.minuteShort'
		)}`;
	}, [requirement.config]);

	const message = $t('jurisdictionRequirements.ukCooldown.message', {
		countdown: countdown
	});

	return {
		message
	};
};
